<template>
    <div class="load-more-wrapper" :class="{'remove-table-styles': removeTableStyles}">
        <loader-generic v-if="isLoadingMore" isSmall/>
        <buttons-tertiary v-else buttonSize="small" icon="cycle" :label="t('table.loadMore')" @clicked="emit('loadMore')"/>
    </div>
</template>

<script setup>
import ButtonsTertiary from '@/components/generic/buttons/Tertiary'
import LoaderGeneric from '@/components/generic/loaders/Generic'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/** Props
@isLoadingMore {Boolean} - prop to tell table when to show loader or button
@removeTableStyles {Boolean} - remove table border
*/
const props = defineProps({
    isLoadingMore: Boolean,
    removeTableStyles: Boolean
})

const emit = defineEmits(['loadMore'])
</script>

<style lang="scss" scoped>
.load-more-wrapper {
    width: 100%;
    height: 48px;

    display: flex;
    align-items: center;
    justify-content: center;

    border-top: 0px;
    border-radius: 0 0 8px 8px;

    &:not(.remove-table-styles) {
        border: 1px solid var(--secondary-light-2);
    }
}
</style>
